module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7VSxEYJAENxzLEA7MITMErQDQ8joAE3NxTKMHM1sATswcEZDSqACzgt0eNR/TsHAGTb5uzlul9+/f6BDDeiTj5fXfQzmuYSjkoHyxAuGtp4+tOSX3UbIo5cC88DV14OG/LyNZInwBVQ7oD7FzEYOpLJkml6VADONzXzlh1MoobKoCX4uYB1TGckD3SdE7J88NaWPuCA6rb1gYeOxnwHzjG0lQ1B+IoMDjS0qgKOrbt2BaYPLIlTjdzz1kFtccSvxQ/UT8/9j2gm0I0DEeZkYcYc2cANLUDb5eQU8iwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facebook.png
// module id = 1813
// module chunks = 0